import { Component, Prop, Vue, Model } from 'vue-property-decorator';
import { OrderItem } from '@/models/OrderItem';
import { AxiosError } from 'axios';
import { currency } from '@/support/String';
import ErrorHandler from '@/support/ErrorHandler';

@Component<ShoppingCart>({
  filters : {
    currency(value: string) {
      return !value ? '' : currency(parseFloat(value));
    },
  }
})
export default class ShoppingCart extends Vue {

  @Prop({ default: false })
  protected orderItems!: OrderItem[];

  @Prop()
  protected status!: string;

  public mounted() {
    //
  }

  protected deleteOrderItem(id: string) {
    new OrderItem()
    .deleteOrderItem(this.$route.params.id, id)
    .then((response: any) => {
      this.$emit('orderItemsUpdated');
    })
    .catch((error: AxiosError) => {
      ErrorHandler.network(error);
    });
  }

  protected listOrderItems() {
    new OrderItem()
    .order(this.$route.params.id)
    .include('product')
    .limit(100)
    .all()
    .then((response: any) => {
      this.orderItems = response;
    })
    .catch((error: AxiosError) => {
      console.log('error', error);
    });
  }

  protected get isOrderSetsPage(): boolean {
    return this.$route.name === 'webshop.order.sets';
  }


  protected get totalPrice() {
    let total = 0;
    this.orderItems.forEach((orderItem: OrderItem) => {
      if (orderItem.product) {
       total += Number(orderItem.price);
      }
    })
    return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(total);
  }

  protected createSets() {
    this.$router.push({
      name: 'webshop.order.sets',
    });
  }
}
